<template>
  <div>
    <v-text-field
      label="Yetkili Kişi Adı / Soyadı"
      v-model="localData.authorizedPerson"
      @input="emitUpdate"
      :rules="fullNameRules"
    />
    <v-text-field
      label="Yetkili/Ünvan"
      v-model="localData.authorizedPersonTitle"
      @input="emitUpdate"
    />
    <small style="color: #98a2b3; font-size: 11px; margin-top: -5px;">
      Örnek: Mağaza Sahibi, Operasyon Müdürü
    </small>
    <v-text-field
      label="Eposta Adresi"
      v-model="localData.authorizedPersonMail"
      @input="onEmailChange"
      :rules="emailRules"
      @keydown.space.prevent
    />
  </div>
</template>

<script>
export default {
  name: 'UserInfoForm',
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData },
      emailRules: [
        (v) => !!v || 'Email alanı zorunludur.',
        (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'Lütfen geçerli bir mail adresi giriniz.',
      ],
      fullNameRules: [
        (v) => !!v || 'Ad ve soyadı doğru bir formatta yazınız.',
        (v) => v.length <= 255 || 'Ad ve soyadı doğru bir formatta yazınız.',
        (v) => {
          const parts = v
            .trim()
            .split(' ')
            .filter((part) => part.length > 0)
          return (
            (parts.length >= 2 && parts.every((part) => part.length >= 2)) ||
            'Ad ve soyadı doğru bir formatta yazınız.'
          )
        },
        (v) =>
          /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]*$/.test(v) ||
          'Ad ve soyadı doğru bir formatta yazınız.',
      ],
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update-form-data', 'userInfo', this.localData)
    },
    onEmailChange(value) {
      this.localData.authorizedPersonMail = value.replaceAll(' ', '')
      this.emitUpdate()
    },
  },
}
</script>
<style>
.custom_radio {
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 12px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  gap: 12px;
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0 !important;
}
</style>
